import PropTypes from 'prop-types';
import React from 'react';
import cx from 'classnames';
import capitalize from 'lodash/capitalize';
import Link from '@piconetworks/pkg-link';
import Icon from '@piconetworks/pkg-icon';
import styles from './SocialLinks.module.scss.js';

var DefaultIcon = Icon.Default;
var sortOrder = ['instagram', 'threads', 'tiktok', 'youtube', 'twitter', 'email', 'website', 'venmo', 'cash_app', 'spotify', 'apple_music', 'apple_podcasts', 'etsy', 'pinterest', 'twitch', 'discord', 'snapchat', 'facebook', 'linkedin', 'github'];
var SocialLinks = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var links = _ref.links,
    _ref$onClick = _ref.onClick,
    onClick = _ref$onClick === void 0 ? function () {} : _ref$onClick;
  return links.filter(function (link) {
    return sortOrder.indexOf(link.type) !== -1;
  }).sort(function (a, b) {
    return sortOrder.indexOf(a.type) - sortOrder.indexOf(b.type);
  }).map(function (_ref2, i) {
    var id = _ref2.id,
      type = _ref2.type,
      url = _ref2.url;
    var iconType = capitalize(type);
    return type && /*#__PURE__*/React.createElement(Link, {
      className: cx(styles.socialLink, styles[type]),
      hideText: true,
      href: url,
      icon: DefaultIcon["Social" + iconType] ? /*#__PURE__*/React.createElement(DefaultIcon["Social" + iconType], {
        className: type + "-icon"
      }) :
      /*#__PURE__*/
      // This prevents app from crashing if logo doesn't exist.
      React.createElement("span", {
        className: styles.noSvg
      }),
      key: i,
      openNewWindow: true,
      ref: ref,
      type: type,
      variant: null,
      hrefClick: function hrefClick() {
        return onClick({
          link_id: id,
          link_url: url,
          link_social_type: type,
          link_type: 'social'
        });
      }
    }, type);
  });
});
SocialLinks.displayName = 'SocialLinks';
SocialLinks.propTypes = {
  links: PropTypes.array
};

export { SocialLinks as default };
//# sourceMappingURL=index.js.map
